import Skeleton from "common/components/ui/Skeleton";
import type { CampaignOutreachType } from "common/types";

import { CAMPAIGN_OUTREACH_OPTIONS } from "../../../constants";
import useCampaignMetrics from "../../../datahooks/useCampaignMetrics";

interface CampaignMetricsProps {
  id: string;
  outreachType: CampaignOutreachType;
}

export default function CampaignMetrics({
  id,
  outreachType,
}: CampaignMetricsProps) {
  const { campaignMetrics, isLoadingCampaignMetrics } = useCampaignMetrics(id);

  if (isLoadingCampaignMetrics) return <Skeleton className="h-[18px] w-16" />;

  if (!campaignMetrics) return "-";

  const stringValue =
    CAMPAIGN_OUTREACH_OPTIONS[outreachType].getSuccessString(campaignMetrics);
  // biome-ignore lint/security/noGlobalEval: this usage is safe since the value comes from the server
  const numberValue = eval(stringValue);

  return (
    <span className="text-nowrap">
      {stringValue} ({numberValue ? Math.round(numberValue * 100) : 0}%)
    </span>
  );
}
